import { isOfVariant } from 'variant';
import type { CliError } from './cli-error.js';
import { CliErrorCode, CliSystemErrorCode } from './cli-error-codes.js';

export function isCliError(error: unknown): error is CliError {
  if (error && typeof error === 'object' && 'cliCode' in error) {
    return isOfVariant(error.cliCode, CliErrorCode);
  }

  return false;
}

export function isCliSystemError(error: CliError): boolean {
  return isOfVariant(error.cliCode, CliSystemErrorCode);
}
